import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'feetAndInches' })
export class FeetAndInchesPipe implements PipeTransform {
  public transform(input: number | string, wordCount?: number): string {
    if (!input) return ''
    const num = parseInt(input.toString(), 10)
    if (isNaN(num)) return ''
    const feet = Math.floor(num / 12)
    const inches = num % 12
    return `${feet}' ${inches}"`
  }
}
